import { CalcStorageDaysService } from './../../services/calc-storage-days.service';
import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { element } from 'protractor';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { TypeMessage, ActionMessage } from 'src/app/entity/enum/enum-notification';


import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import * as moment from 'moment';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import { MatDialog } from '@angular/material/dialog';
import { FormCamisaTrieur } from 'src/app/entity/forms/form-camisa-trieur';
import { CamisaTrieurCardIComponent } from './partial-views/camisa-trieur-card-I.component';
import { CamisaTrieurCardIIComponent } from './partial-views/camisa-trieur-card-II.component';
import { CamisaTrieurCardIIIComponent } from './partial-views/camisa-trieur-card-III.component';
import { CamisaTrieurCardIVComponent } from './partial-views/camisa-trieur-card-IV.component';


@Component({
    selector: 'app-form-camisa-trieur',
    templateUrl: './form-camisa-trieur.component.html'
})

export class FormCamisaTrieurComponent implements OnInit, AfterViewInit {

    public header?: CabecalhoDTO;
    public formulario?: FormGroup;
    public btnCollapse?: boolean;
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public enableButtons = this.loadingSubject.asObservable();
    public formCamisaTrieur: FormCamisaTrieur = new FormCamisaTrieur();
    public listSiloProp?: Array<any> = new Array<any>();
    public listCd006OnContract?: Array<any> = new Array<any>();
    public areaSelect: string = localStorage.getItem('area-select') || null;
    valuesInitial: any;
    valoresAlterados: any[] = [];


    @ViewChild(CamisaTrieurCardIComponent, { static: false }) camisaTrieurCardIComponent: CamisaTrieurCardIComponent;
    @ViewChild(CamisaTrieurCardIIComponent, { static: false }) camisaTrieurCardIIComponent: CamisaTrieurCardIIComponent;
    @ViewChild(CamisaTrieurCardIIIComponent, { static: false }) camisaTrieurCardIIIComponent: CamisaTrieurCardIIIComponent;
    @ViewChild(CamisaTrieurCardIVComponent, { static: false }) camisaTrieurCardIVComponent: CamisaTrieurCardIVComponent;

    camposPorcentagem: any;
    notificationC3: boolean = false
    notificationC2: boolean = false
    siloDestino: any;
    currentUser: string = "";
    constructor(
        protected formBuilder: FormBuilder,
        protected generalService: GeneralService,
        protected notificationService: NotificationService,
        protected formularioService: FormularioService,
        protected route: ActivatedRoute,
        protected calcStorageDaysService: CalcStorageDaysService,
        protected resumeAllFormsService: ResumeAllFormsService,
        public dialog: MatDialog) {
        this.header = new CabecalhoDTO();
        this.formulario = this.formCamisaTrieur.createFormCamisaTrieur(formBuilder);
    }

    async ngAfterViewInit(): Promise<void> {
        await this.route.data.subscribe(async (data: any) => {
            if (!!data) {
                this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();
                const type = (this.route?.snapshot?.params?.type);
                const isReadOnly: boolean = type === '2' ? true : false;
                this.loadingSubject.next(isReadOnly ? false : true);
                if (type === '1' || type === '2' || type === '3') {
                    await this.updateForm(data);
                    if (type === '1') {
                        this.header = this.generalService.createHeader(EnumForm.FormCamisaTrieur, EnumFormType.Edit);
                    } else if (type === '3') {
                        this.header = this.generalService.createHeader(EnumForm.FormCamisaTrieur, EnumFormType.Duplicate);
                        this.formulario.get('id').setValue(null);
                        localStorage.setItem('duplicate', '3');
                    }
                    else {
                        this.header = this.generalService.createHeader(EnumForm.FormCamisaTrieur, EnumFormType.Details);
                    }


                } else {
                    this.header = this.generalService.createHeader(EnumForm.FormCamisaTrieur, EnumFormType.New);
                    localStorage.removeItem('duplicate')
                    await this.getUser();

                }
            }
        });
    }


    ngOnInit(): void {
        this.header = this.generalService.createHeader(EnumForm.FormCamisaTrieur, EnumFormType.New);
        this.btnCollapse = true;
        this.loadingSubject.next(false);

    }

    async save(): Promise<void> {

        const id: number = this.formulario.get('id').value as number;
        const isAddFlow = id === 0;
        if (await this.validFormsToSave() === '') {
            await this.buildFormulario();
            this.formulario.get('origem_negocio').setValue(String(this.generalService.areaSelect));

            await this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'camisa_trieur');
            this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);
        }

    }

    public async openConfirmDialog(valoresAlterados: any[], isAddFlow): Promise<void> {

        const values: any[] = valoresAlterados;

        const dialogRef = this.dialog.open(FormModalConfirmComponent, {

            data: {
                valoresAlterados: values,
                isAddFlow

            }

        });
        dialogRef.afterClosed().subscribe(x => {
            if (x.save) {
                const id: number = this.formulario.get('id').value as number;
                this.formularioService.saveForm(id, this.formulario.getRawValue(), 'camisa_trieur', 'camisa-trieur');
            }
            else {
                this.resumeAllFormsService.valoresAlterados = [];
            }


        })

    }

    async getForms(): Promise<FormGroup[]> {
        const arrForms: Array<FormGroup> = new Array<FormGroup>();

        arrForms.push(this.camisaTrieurCardIComponent.formulario);
        arrForms.push(this.camisaTrieurCardIIComponent.formulario);
        arrForms.push(this.camisaTrieurCardIIIComponent.formulario);
        arrForms.push(this.camisaTrieurCardIVComponent.formulario);
        return await arrForms;
    }

    async validFormsToSave(): Promise<string> {
        return await this.formularioService.validForm(await this.getForms());
    }

    async cleanAll(): Promise<void> {
        await this.formularioService.cleanForm(await this.getForms());
    }

    async collapseAll(): Promise<void> {
        this.btnCollapse = this.btnCollapse ? false : true;
        this.camisaTrieurCardIComponent.collapseCard = this.btnCollapse ? false : true;
        this.camisaTrieurCardIIComponent.collapseCard = this.btnCollapse ? false : true;
        this.camisaTrieurCardIIIComponent.collapseCard = this.btnCollapse ? false : true;
        this.camisaTrieurCardIVComponent.collapseCard = this.btnCollapse ? false : true;
    }

    public async buildFormulario(): Promise<void> {

        this.formulario = await this.formCamisaTrieur.buildForm(this.formulario, await this.getForms(), this.generalService);
    }

    public async updateForm(data?: any): Promise<void> {

        this.formulario.get('id').setValue(data.formulario.id);

        await this.formCamisaTrieur.updateForm(data, await this.getForms(), this.generalService);

        this.camisaTrieurCardIComponent.getListLoteDS(null)
        this.camisaTrieurCardIComponent.onChangeLotDS(null)

    }

    private async getUser(): Promise<void> {
        await this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {
            this.formulario.get('responsavel_lancamento').setValue(response['user-profile']?.displayName ?? 'Administrador');
            this.currentUser = response['user-profile']?.displayName ?? 'Administrador';
            this.camisaTrieurCardIVComponent.formulario.get('criado_por').setValue(this.currentUser);
        }).catch(async error => {
            await this.generalService.getUserNameValue().pipe(take(1)).toPromise().then((response: string) => {
                this.formulario.get('responsavel_lancamento').setValue(response ?? 'Administrador');
                this.camisaTrieurCardIVComponent.formulario.get('criado_por').setValue(response ?? 'Administrador');

            }).catch(err => {
            });
        });
    }

    makeCalcCardII(dados) {
        console.log("evet", dados);

        //CALC Rendimento
        var sum_rendimento_R1M = 0;
        var sum_rendimento_C1M = 0;
        var sum_rendimento_R2 = 0;
        var sum_rendimento_C2 = 0;
        var sum_rendimento_R3 = 0;
        var sum_rendimento_C3 = 0;

        //CALC Min
        var sum_min_R1M = 0;
        var sum_min_C1M = 0;
        var sum_min_R2 = 0;
        var sum_min_C2 = 0;
        var sum_min_R3 = 0;
        var sum_min_C3 = 0;

        //CALC Max
        var sum_max_R1M = 0;
        var sum_max_C1M = 0;
        var sum_max_R2 = 0;
        var sum_max_C2 = 0;
        var sum_max_R3 = 0;
        var sum_max_C3 = 0;

        //CALC SDEV
        var sum_sdev_R1M = 0;
        var sum_sdev_C1M = 0;
        var sum_sdev_R2 = 0;
        var sum_sdev_C2 = 0;
        var sum_sdev_R3 = 0;
        var sum_sdev_C3 = 0;

        var divide = 0


        if (dados.length > 0) {
            dados.forEach(element => {

                //CALC Rendimento
                sum_rendimento_R1M += element.r1_prc * element.volume_ds
                sum_rendimento_C1M += element.c1_prc * element.volume_ds
                sum_rendimento_R2 += element.r2_prc * element.volume_ds
                sum_rendimento_C2 += element.c2_prc * element.volume_ds
                sum_rendimento_R3 += element.r3_prc * element.volume_ds
                sum_rendimento_C3 += element.c3_prc * element.volume_ds

                //CALC Min
                sum_min_R1M += element.r1_min * element.volume_ds
                sum_min_C1M += element.c1_min * element.volume_ds
                sum_min_R2 += element.r2_min * element.volume_ds
                sum_min_C2 += element.c2_min * element.volume_ds
                sum_min_R3 += element.r3_min * element.volume_ds
                sum_min_C3 += element.c3_min * element.volume_ds

                //CALC Max
                sum_max_R1M += element.r1_max * element.volume_ds
                sum_max_C1M += element.c1_max * element.volume_ds
                sum_max_R2 += element.r2_max * element.volume_ds
                sum_max_C2 += element.c2_max * element.volume_ds
                sum_max_R3 += element.r3_max * element.volume_ds
                sum_max_C3 += element.c3_max * element.volume_ds

                //CALC SDEV
                sum_sdev_R1M += element.r1_sdev * element.volume_ds
                sum_sdev_C1M += element.c1_sdev * element.volume_ds
                sum_sdev_R2 += element.r2_sdev * element.volume_ds
                sum_sdev_C2 += element.c2_sdev * element.volume_ds
                sum_sdev_R3 += element.r3_sdev * element.volume_ds
                sum_sdev_C3 += element.c3_sdev * element.volume_ds


                divide += element.volume_ds
            });

            //SET Rendimento
            this.camisaTrieurCardIIComponent.formulario?.get('rendimento_r1m').setValue(Number(Number(sum_rendimento_R1M / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('rendimento_c1m').setValue(Number(Number(sum_rendimento_C1M / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('rendimento_r2').setValue(Number(Number(sum_rendimento_R2 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('rendimento_c2').setValue(Number(Number(sum_rendimento_C2 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('rendimento_r3').setValue(Number(Number(sum_rendimento_R3 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('rendimento_c3').setValue(Number(Number(sum_rendimento_C3 / divide).toFixed(2)));

            //SET Min
            this.camisaTrieurCardIIComponent.formulario?.get('min_r1m').setValue(Number(Number(sum_min_R1M / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('min_c1m').setValue(Number(Number(sum_min_C1M / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('min_r2').setValue(Number(Number(sum_min_R2 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('min_c2').setValue(Number(Number(sum_min_C2 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('min_r3').setValue(Number(Number(sum_min_R3 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('min_c3').setValue(Number(Number(sum_min_C3 / divide).toFixed(2)));

            //SET Max
            this.camisaTrieurCardIIComponent.formulario?.get('max_r1m').setValue(Number(Number(sum_max_R1M / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('max_c1m').setValue(Number(Number(sum_max_C1M / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('max_r2').setValue(Number(Number(sum_max_R2 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('max_c2').setValue(Number(Number(sum_max_C2 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('max_r3').setValue(Number(Number(sum_max_R3 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('max_c3').setValue(Number(Number(sum_max_C3 / divide).toFixed(2)));

            //SET SDEV
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_r1m').setValue(Number(Number(sum_sdev_R1M / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_c1m').setValue(Number(Number(sum_sdev_C1M / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_r2').setValue(Number(Number(sum_sdev_R2 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_c2').setValue(Number(Number(sum_sdev_C2 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_r3').setValue(Number(Number(sum_sdev_R3 / divide).toFixed(2)));
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_c3').setValue(Number(Number(sum_sdev_C3 / divide).toFixed(2)));


            this.camisaTrieurCardIComponent.formulario?.get('volume_analisado').setValue(divide);

            //SET Ranges
            this.setRanges();
            this.setResultados();
        }
    }

    setRanges() {
        this.camisaTrieurCardIIComponent.formulario?.get('range_r1m').setValue(
            this.camisaTrieurCardIIComponent.formulario?.get('max_r1m').value -
            this.camisaTrieurCardIIComponent.formulario?.get('min_r1m').value
        );

        this.camisaTrieurCardIIComponent.formulario?.get('range_c1m').setValue(
            this.camisaTrieurCardIIComponent.formulario?.get('max_c1m').value -
            this.camisaTrieurCardIIComponent.formulario?.get('min_c1m').value
        );

        this.camisaTrieurCardIIComponent.formulario?.get('range_r2').setValue(
            this.camisaTrieurCardIIComponent.formulario?.get('max_r2').value -
            this.camisaTrieurCardIIComponent.formulario?.get('min_r2').value
        );

        this.camisaTrieurCardIIComponent.formulario?.get('range_c2').setValue(
            this.camisaTrieurCardIIComponent.formulario?.get('max_c2').value -
            this.camisaTrieurCardIIComponent.formulario?.get('min_c2').value
        );

        this.camisaTrieurCardIIComponent.formulario?.get('range_r3').setValue(
            this.camisaTrieurCardIIComponent.formulario?.get('max_r3').value -
            this.camisaTrieurCardIIComponent.formulario?.get('min_r3').value
        );

        this.camisaTrieurCardIIComponent.formulario?.get('range_c3').setValue(
            this.camisaTrieurCardIIComponent.formulario?.get('max_c3').value -
            this.camisaTrieurCardIIComponent.formulario?.get('min_c3').value
        );
    }

    setResultados() {
        //R1M
        if (this.camisaTrieurCardIIComponent.formulario?.get('range_r1m').value < 5.5 &&
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_r1m').value < 0.94) {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_r1m').setValue('APROVADO');
        }
        else {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_r1m').setValue('REPROVADO');
        }

        //C1M
        if (this.camisaTrieurCardIIComponent.formulario?.get('range_c1m').value < 5.5 &&
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_c1m').value < 0.94) {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_c1m').setValue('APROVADO');
        }
        else {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_c1m').setValue('REPROVADO');
        }

        //R2
        if (this.camisaTrieurCardIIComponent.formulario?.get('range_r2').value < 4 &&
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_r2').value < 0.84) {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_r2').setValue('APROVADO');
        }
        else {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_r2').setValue('REPROVADO');
        }

        //C2
        if (this.camisaTrieurCardIIComponent.formulario?.get('range_c2').value < 4 &&
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_c2').value < 0.84) {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_c2').setValue('APROVADO');
        }
        else {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_c2').setValue('REPROVADO');
        }

        //R3
        if (this.camisaTrieurCardIIComponent.formulario?.get('range_r3').value < 3.9 &&
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_r3').value < 0.74) {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_r3').setValue('APROVADO');
        }
        else {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_r3').setValue('REPROVADO');
        }

        //C3
        if (this.camisaTrieurCardIIComponent.formulario?.get('range_c3').value < 3.9 &&
            this.camisaTrieurCardIIComponent.formulario?.get('sdev_c3').value < 0.74) {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_c3').setValue('APROVADO');
        }
        else {
            this.camisaTrieurCardIIComponent.formulario?.get('resultado_c3').setValue('REPROVADO');
        }
    }

}
